import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.SlotField = class SlotField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, "change:validated_appointment_slot", this.render);
  }
};
AppointmentBooking.Wizard.Views.ConfirmationStep.SlotField.prototype.template = "step/confirmation/fields/slot";
AppointmentBooking.Wizard.Views.ConfirmationStep.SlotField.prototype.className =
  "appointment-booking-wizard-confirmation-step-slot-select-field";
